
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- start of search -->
    <div class="search-area">
      <el-row :gutter="24">
        <!-- 名称 -->
        <el-col :span="6">
          <div class="search-area-div">名称</div>
          <el-input v-model="dicName" size="mini" class="ipt-sty" placeholder="请输入名称" :clearable="true"></el-input
        ></el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="getData()">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- end of search -->

    <!-- start of content -->
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <div>
          <el-button size="mini" type="info" @click="add(1, '')">新增商品大类</el-button>
          <el-button size="mini" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
          <div style="float: right;">
            <span style="color:red">重要说明: 一级大类若需要修改名称请联系管理员</span>
          </div>
        </div>
      </div>

      <el-table
        v-loading="loading"
        stripe border
        row-key="guid"
        style="width: 100%"
        :height="tableHeight"
        :data="tableList"
        :tree-props="{ children: 'childList', hasChildren: 'hasChildren' }"
        :expand-row-keys="expandRowKeys"
        @expand-change="expandChange"
        @selection-change="handleSelectionChange"
      >
        <!-- selection -->
        <el-table-column type="selection" width="60" header-align="center" align="center" fixed="left"></el-table-column>
        <!-- 名称 -->
        <el-table-column prop="dicName" label="名称" header-align="center" align="left" fixed="left" show-overflow-tooltip></el-table-column>
        <!-- 排序 -->
        <el-table-column prop="orderNum" label="排序" width="60" header-align="center" align="center"></el-table-column>
        <!-- 状态 -->
        <el-table-column prop="bizState" label="状态" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.bizState == 'Y' ? '有效' : '无效' }}
          </template>
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column prop="createTime" width="120" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="left" width="120" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row)">编辑｜</a>
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- end of content -->

    <!-- start of 新增|编辑商品大类 -->
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px" :close-on-click-modal="false">
      <el-form
        :model="formData"
        :rules="formRules"
        ref="formData"
        label-width="120px"
        label-position="right"
        class="form-box"
      >
        <el-form-item label="商品大类名称" prop="dicName">
          <el-input
            oninput="if(value.length>25)value=value.slice(0, 25)"
            v-model="formData.dicName"
            autocomplete="off"
            class="w100f"
            size="small"
            placeholder="请输入商品大类名称"
          ></el-input>
        </el-form-item>
        <!-- 上级分类 -->
        <el-form-item label="上级分类" prop="parentGuid">
          <el-cascader
            placeholder="请选择上级"
            class="w100f"
            ref="cascaderAddr"
            clearable
            filterable
            v-model="formData.parentGuid"
            :options="tableList"
            :props="cascaderProps"
          ></el-cascader>
        </el-form-item>
        <!-- 排序 -->
        <el-form-item label="排序" prop="orderNum">
          <el-input v-model="formData.orderNum" oninput="if(value.length>8)value=value.slice(0, 8)" onkeyup="this.value = this.value.replace(/\D/g, '')" autocomplete="off" class="w100f" size="small" placeholder="请输入排序"></el-input>
        </el-form-item>
        <!-- 业务状态 -->
        <el-form-item label="业务状态" prop="bizState" style="width: 50%">
          <el-radio-group v-model="formData.bizState">
            <el-radio label='Y'>有效</el-radio>
            <el-radio label='S'>无效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="info" @click="submitForm('formData')">确定</el-button>
      </div>
    </el-dialog>
    <!-- end of 新增|编辑商品大类 -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 280,
      dicName: '',
      tableList: [],
      formData: {
        dicName: '', // 商品大类名称，字典名称
        parentGuid: '', // 上级分类，父级id
        orderNum: '', // 序号，排序
        bizState: 'Y', // 状态，Y有效 S无效
      },
      formRules: {
        dicName: [
          { required: true, message: '请输入商品大类名称', trigger: 'blur' },
        ],
        orderNum: [
          { required: true, message: '请输入排序', trigger: 'blur' },
        ],
      },
      textTitle: '',
      dialogFormVisible: false,
      loading: false,
      
      fullscreenLoading:false,
      
      goodsCodeList:[],
      // 级联
      cascaderProps: {
        value: 'guid',
        label: 'dicName',
        children: 'childList',
        multiple: false,
        emitPath: false,
        checkStrictly: true
      },
      expandRowKeys:[],
      multipleSelection: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /**
     * 清空搜索数据
     */
    empty() {
      this.dicName = '';
      this.getData();
    },
    /**
     * 获取列表数据
     */
    getData() {
      let self = this;
      self.loading = true;
      self.tableList = [];
      self.api.get(
        `/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dictType=商品大类字典&dicName=` + self.dicName
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          let datas = res.data.data || [];
          self.tableList = datas;
        } else {
          self.$message.error(res.msg || '服务异常');
          console.log(res);
          self.loading = false;
        }
      });
    },
    /**
     * 新增|编辑弹框
     * @param {*} flg 1新增 2编辑
     * @param {*} row 编辑行时的数据
     */
    add(flg, row) {
      let self = this;
      if (flg == 1) {
        self.textTitle = '添加商品大类';
        self.formData = {
          dicName: '', // 商品大类名称，字典名称
          parentGuid: '', // 上级分类，父级id
          orderNum: '', // 序号，排序
          bizState: 'Y', // 状态，Y有效 S无效
        };
      } else {
        self.textTitle = '编辑商品大类';
        self.formData = JSON.parse(JSON.stringify(row));
      }
      self.dialogFormVisible = true;
    },
    /**
     * 新增时提交表单
     * @param {*} formName 
     */
    submitForm(formName) {
      let self = this;
      // 如果没有选择上级分类，则需要将商品大类字典第一级的guid传给后台
      if(!self.formData['parentGuid'] && localStorage.codeList) {
        let codeList = JSON.parse(localStorage.codeList);
        let list = codeList.filter(item => item.dictTypeName == '商品大类字典')
        self.formData['parentGuid'] = list[0]['guid'];
      }

      self.$refs[formName].validate((valid) => {
        if (valid) {
          self.api.postJson(`/${serverConfig.msConfigureService}/dict/save-dict`, self.formData).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              // 新增、修改提示语判断
              if(self.textTitle = '添加商品大类') {
                self.$message.success('添加成功');
              }else {
                self.$message.success('编辑成功');
              }
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 行展开关闭
     */
    expandChange(row, expandedRows){
      if(expandedRows){
        if(this.expandRowKeys && this.expandRowKeys.length > 0){
          let flg = false;
          this.expandRowKeys.forEach(i =>{
            if(row.guid == i){
              flg = true;
            }
          })
          if(!flg){
            this.expandRowKeys.push(row.guid);
          }
        }else{
          this.expandRowKeys.push(row.guid);
        }
        
      }else{
        this.expandRowKeys.forEach((i,index) =>{
          if(i.guid == row.guid){
            this.expandRowKeys.splice(index,1);
          }
        })
      }
      console.log('展开',this.expandRowKeys)
    },
    /**
     * 勾选数据
     */
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        self.multipleSelection.push(item.guid); // item 就是当日按循环到的对象
      }) 
    },
    /**
     * 删除数据
     * @param {*} flg 1批量删除 2单行数据删除
     * @param {*} guid 
     */
    getDeleteData(flg, guid) {
      let self = this;
      if(flg == 1 && self.multipleSelection.length == 0){
        return  self.$message.error("请勾选数据！");
      }

      if(flg == 2) {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.api.postJson(`/${serverConfig.msConfigureService}/dict/del`, self.multipleSelection)
        .then((res) => {
          if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
            if(self.expandRowKeys && self.expandRowKeys.length > 0){
              self.expandRowKeys.forEach((i,index1)=>{
                self.multipleSelection.forEach((j,index2)=>{
                  if (i === j) {
                    self.expandRowKeys.splice(index1, 1, "del")
                  }
                })
              })
              self.expandRowKeys = self.expandRowKeys.filter(item => item !== "del")
            }
            self.multipleSelection = [];
            self.$message.success('删除成功');
            self.getData(true);
          }else {
            self.$message.error(res.data.msg);
          }
        }) 
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    }
  },
};
</script>
<style lang="less" scoped>
.form-box {
  .el-form-item {
    margin-bottom: 18px;
  }
}
</style>
